// Copyright (c) 2016 Deere & Company

import Facets from './state/facets';
import TransferApprovals from './components/transfer-approvals';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';
import reports from '../../routes/products/reports';

const getStateToBindToContainerProps = state => ({
    ...state.transferApprovals,
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    dealerRecommendationCount: state.dealerRecommendationsReducer.dealerRecommendations.totalElements,
    duplicatePinPlateCount: state.factoryDuplicatePinPlate.factoryDuplicatePinPlates.length,
    exportToExcel: state.exportToExcel,
    facets: new Facets({
        ...state.transferApprovals.facets,
        dealerAccountsFacet: {
            ...state.transferApprovals.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    highRentalDaysCount: state.productSearch.highRentalDays.highdayscount,
    isSapUp: state.app.sapStatus.isSapUp,
    machineStatusUpdateCount: state.machineStatusUpdate.machineStatusUpdates.length,
    registrationReviewCount: state.registrationReview.registrations.length,
    reportsRoutes: reports(),
    searchResultsCount: state.productSearch.searchResults.length,
    security: state.user.security,
    transferApprovalsCount: state.home.wip.productTracking.transferApprovals,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(TransferApprovals);



// WEBPACK FOOTER //
// ./src/product/transfers/state-connector.js